import Product from '@views/ProductView';
/**
 * Example using code splitting and componentization. The run-time imports will cause bundle split
 * points for webpack, and as a result, load chunks on-demand (when navigating between routes).
 *
 * @see https://webpack.js.org/guides/code-splitting/#dynamic-imports
 */
const devRoutes = [
  {
    name: 'home',
    path: '/',
    component: () => import('./app'),
  },
  {
    path: '/EventsWar/events/pixel/customeraction', // skips this route for dev mode to avoid terminal warnings
    beforeEnter: (to, from, next) => {
      next(false);
    },
    component: () => import('./app'),
  },
];

const qaRoutes = [
  {
    name: 'home',
    path: '/',
    component: () => import('./app'),
  },
];

const productionRoutes = [
  {
    name: 'product',
    path: '/shop/product/:name(.*)',
    alias: ['/shop/registry/wedding/product/:name'],
    component: Product,
    meta: {
      noScroll: true,
    },
  },
  {
    name: 'productWithoutName',
    path: '/shop/product',
    component: Product,
    meta: {
      noScroll: true,
    },
  },
  {
    name: 'writeReview',
    path: '/shop/product/review/add',
    component: () => import('@views/WriteReview'),
  },
];

export default () => {
  if (process.env.NODE_ENV === 'development') {
    return [...productionRoutes, ...devRoutes];
  } if (process.env.NODE_ENV === 'qa') {
    return [...productionRoutes, ...qaRoutes];
  }

  return productionRoutes;
};
